import { Tabs } from 'antd';
import TabPane from 'antd/lib/tabs/TabPane';
import React, { useEffect } from 'react'
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { createCookie, readCookie } from '../../../../config/CookieScript';
import { setHeaderName } from '../../../../services/SetHeaderName';
import { BPTypes } from './components/BPTypes';
import { City } from './components/City';
import { Country } from './components/Country';
import { DietTime } from './components/DietTime';
import { DietTypes } from './components/DietTypes';
import { Diseases } from './components/Diseases';
import { FocusHealthAreas } from './components/FocusHealthAreas';
import { HerbsManagement } from './components/HerbsManagement';
import { MeasurementsTypes } from './components/MeasurementsTypes';
import { MeasurementsUnit } from './components/MeasurementsUnit';
import { MenstrualHistory } from './components/MenstrualHistory';
import { PhenotypeQuestions } from './components/PhenotypeQuestions';
import { QuestionDomain } from './components/QuestionDomain';
import { ReasonOfWeightLoss } from './components/ReasonOfWeightLoss';
import { RoutineDiet } from './components/RoutineDiet';
import { State } from './components/State';
import './style/Patient.scss'

export const Patient = () => {
    const [activeTab, setActiveTab] = useState('1')

    const manageTab = (tabKey) => {
        // setActiveTab(tabKey)
        // if(!readCookie('PatientTabKey')){
        createCookie('PatientTabKey', tabKey)
        // }
    }

    useEffect(() => {
        setHeaderName("Patient Master")
    }, []);
    return (
        <div className="patient-master">
            <Tabs
                defaultActiveKey={readCookie('PatientTabKey') || activeTab}
                onChange={(e) => manageTab(e)}
                type="card"
                tabPosition='left'
            >
                <TabPane tab="Menstrual History" key="1">
                    <MenstrualHistory />
                </TabPane>
                <TabPane tab="Reason of Weight Loss" key="2">
                    <ReasonOfWeightLoss />
                </TabPane>
                <TabPane tab="Diseases" key="3">
                    <Diseases />
                </TabPane>
                <TabPane tab="BPTypes" key="4">
                    <BPTypes />
                </TabPane>
                <TabPane tab="Routine Diet" key="5">
                    <RoutineDiet />
                </TabPane>
                <TabPane tab="Diet Time" key="6">
                    <DietTime />
                </TabPane>
                <TabPane tab="Diet Types" key="16">
                    <DietTypes />
                </TabPane>
                <TabPane tab="Measurements Unit" key="7">
                    <MeasurementsUnit />
                </TabPane>
                <TabPane tab="Measurements type" key="8">
                    <MeasurementsTypes />
                </TabPane>
                {/* <TabPane tab="Herbs Management" key="9">
                    <HerbsManagement />
                </TabPane> */}
                <TabPane tab="Question Domain" key="10">
                    <QuestionDomain />
                </TabPane>
                <TabPane tab="Phenotype Questions" key="11">
                    <PhenotypeQuestions />
                </TabPane>
                <TabPane tab="Focus Health Area" key="12">
                    <FocusHealthAreas />
                </TabPane>
                <TabPane tab="Country" key="13">
                    <Country />
                </TabPane>
                <TabPane tab="State" key="14">
                    <State />
                </TabPane>
                <TabPane tab="City" key="15">
                    <City />
                </TabPane>

                {/* <TabPane tab="Measurements" key="9">
                    <MeasurementsMaster />
                </TabPane> */}
            </Tabs>
        </div >
    )
}
